import axios, { AxiosRequestConfig } from 'axios';

import { StorageEnum } from '../enumerators/Storage.enum';

function getInstance(bitrise = false) {
	const defaultOptions: AxiosRequestConfig = getObject(bitrise);

	const instance = axios.create(defaultOptions);

	return instance;
}

function getObject(bitrise = false): AxiosRequestConfig {
	const gitlabToken = localStorage.getItem(StorageEnum.GITLAB_TOKEN);
	const bitriseToken = localStorage.getItem(StorageEnum.BITRISE_TOKEN);

	return {
		baseURL: window.RUNTIME_CONFIG.REACT_APP_GITLAB_ADRESS,
		method: 'get',
		headers: {
			Authorization: bitrise ? bitriseToken : `Bearer ${gitlabToken}`,
			'Content-Type': 'application/json',
			'Access-Control-Allow-Credentials': 'true',
			'Access-Control-Allow-Origin': '*',
			'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
			'Access-Control-Allow-Headers': 'X-CSRF-Token, X-Requested-With, Accept, Accept-Version, Content-Length, Content-MD5, Content-Type, Date, X-Api-Version',
		},
	};
}

export { getInstance };
